/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Row_Price_LabelInputs */

const en_platform_row_price_label = /** @type {(inputs: Platform_Row_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`price`)
};

const zh_hans1_platform_row_price_label = /** @type {(inputs: Platform_Row_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格`)
};

const pt_br2_platform_row_price_label = /** @type {(inputs: Platform_Row_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`preço`)
};

const es_platform_row_price_label = /** @type {(inputs: Platform_Row_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`precio`)
};

const fr_platform_row_price_label = /** @type {(inputs: Platform_Row_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prix`)
};

const de_platform_row_price_label = /** @type {(inputs: Platform_Row_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis`)
};

const ru_platform_row_price_label = /** @type {(inputs: Platform_Row_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`цена`)
};

const it_platform_row_price_label = /** @type {(inputs: Platform_Row_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prezzo`)
};

/**
* | output |
* | --- |
* | "price" |
*
* @param {Platform_Row_Price_LabelInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_row_price_label = /** @type {((inputs?: Platform_Row_Price_LabelInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Row_Price_LabelInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_row_price_label(inputs)
	if (locale === "pt-BR") return pt_br2_platform_row_price_label(inputs)
	if (locale === "es") return es_platform_row_price_label(inputs)
	if (locale === "fr") return fr_platform_row_price_label(inputs)
	if (locale === "de") return de_platform_row_price_label(inputs)
	if (locale === "ru") return ru_platform_row_price_label(inputs)
	if (locale === "it") return it_platform_row_price_label(inputs)
	return en_platform_row_price_label(inputs)
});